<div class="HeaderProfile uk-navbar-item" *ngIf="userService.user">
	<span *ngIf="userService.user.PERSONAL_PHOTO" class="HeaderProfile_Icon uk-background-cover"
		[style.background-image]="'url(' + userService.user.PERSONAL_PHOTO.SRC + ')'"
	></span>
	<span class="uk-visible@m">{{ userService.user.NAME + ' ' + userService.user.LAST_NAME }}</span>
	<a class="IconItem IconItem--signOut" href="#" (click)="signOut($event)">
		<img src="/assets/img/icon/sign-out.svg" uk-svg>
	</a>
</div>
<span *ngIf="!userService.user" class="HeaderProfile_SignIn uk-navbar-item" (click)="signIn()">
	<span class="IconItem IconItem--signIn">
		<img src="/assets/img/icon/sign-in.svg" uk-svg>
	</span>
	Войти
</span>
